import { usePortalApi } from '@/plugins/api/portal';

import type { Context } from '@nuxt/types';
import type { Pinia } from 'pinia';

// требуется для корректной работы chessboard
export default ({ $pinia }: Context): void => {
  $pinia.use(({ store }) => {
    store.apiInstance = usePortalApi().create();
  });
};

declare module 'vue/types/vue' {
  interface Vue {
    $pinia: Pinia;
  }
}
